import { PureComponent } from 'react';
import { capitalize } from '../lib/string';
import ImageWithFallback from './img_with_fallback';
import classes from './profile.less';

type Props = {
  size: 'small' | 'large';
  username: string;
  name: string;
  pictureUrl: string;
};

export default class Profile extends PureComponent<Props> {
  handleProfilePictureClick = () => {
    window.open(`//www.instagram.com/${this.props.username}`, '_blank');
  };
  render() {
    const { username, name, pictureUrl, size } = this.props;
    const suffix = capitalize(size);

    return (
      <div className={classes.profile}>
        <div onClick={this.handleProfilePictureClick}>
          <ImageWithFallback
            src={pictureUrl}
            className={classes[`picture${suffix}`]}
          />
        </div>
        <div className={classes.usernameWrapper}>
          <div className={classes[`username${suffix}`]}>{username}</div>
          {size === 'large' && <div className={classes.name}>{name}</div>}
        </div>
      </div>
    );
  }
}
